<template>
    <v-container grid-list-sm fluid text-xs-center mt-5 pt-5 style="margin-bottom:10%;">
        <v-flex class="row block-content elevation-0 row-container mt-3 border-radius">
            <v-flex class="font-weight-bold p-5">
                <p class="border-radius pt-2 pb-2 text-indic">
                    <v-icon  style="color:#ffa409;font-size:90px!important">&#xe000;</v-icon>
                        <v-card-text>
                            {{$t('contrat.badlinkpayment.title')}}
                    </v-card-text>
                </p>
            </v-flex>
        </v-flex>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>

<style scoped>
    .text-indic{
        color:#ffa409!important;
    }
</style>